import vkarma from '../images/projects/vkarma.png';
import aceportal from '../images/projects/aceportal.png';
import inkalaab from '../images/projects/inkalaab.png';
import oldresume from '../images/projects/oldresume.png';
const project=[
    {
        name: "VKarma",
        about: "Example Sign-up and Login page for internship. This Project is powered by HTML , CSS and JavaScript as core languages.",
        imglink: vkarma,
        link:'https://rohaanmd.github.io/signup_vkarma/',
    },{
        name: "ACE Portal",
        about: "ACE Selection Portal for selecting freshers for ACE-Technical society. This Project is powered by HTML , CSS and JavaScript as core languages.",
        imglink: aceportal,
        link:'https://vipsace.org/portal/',
    },{
        name: "Project INKalaab",
        about: "Project INKalaab is a digital repository aimed at canvassing stories of people in the Indian subcontinent. This Project is powered by SquareSpace. ",
        imglink: inkalaab,
        link: 'https://www.projectinkalaab.com/',
    },{
        name: "RESUME",
        about: "This is a resume showcasing my skills. This Project is powered by HTML , CSS and JavaScript as core languages.",
        imglink: oldresume,
        link: 'https://rohaanmd.github.io/resume-mdrohaan/',
    }
    ,{
        name: "Viva story's admin panel",
        about: "An admin panel for Vivastory company. Powered by reactjs and firebase. its a powerfull tool which enables vivastory's admins to help and solve queries, delete, edit, enable. disable the posts by there users. ",
        imglink: "https://res.cloudinary.com/personal-cloud-rohaanmd/image/upload/v1642747464/viva_vow5ko.png",
        link: 'https://vivastory-rohaan.netlify.app/',
    }
    ,{
        name: "Autogenerate.ai",
        about: "A powerfull tool powered by reactjs. which help user to create bulk AI generated videos.",
        imglink: "https://res.cloudinary.com/personal-cloud-rohaanmd/image/upload/v1642748759/autogenerate_fjcvk9.png",
        link: 'https://autogenerate.ai/',
    },
 
]
export default project;